import { parse } from 'date-fns'

export const parseDate = (dateString, format = 'dd/MM/yyyy') =>
  parse(dateString, format, new Date())
